export const removeModalQuery = str => {
	return str
		.split('&')
		.filter(str => ['page', 'search', 'per_page', 'filter', 'sorts', 'filters'].some(item => str.includes(item)))
		.join('&');
};
